export default __webpack_public_path__ + "static/media/icons8-django.5c82237d.svg";